module.exports = "/public/images/7454cc3cb26f3683d907b033dd75ead7.svg";